module.exports = __webpack_public_path__ + "static/models/kerbs_curve_right.be07b02.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/models/track/models/kerbs_curve_right.json
// module id = 527
// module chunks = 1